var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66797 3.50033C4.66797 2.21166 5.71264 1.16699 7.0013 1.16699C8.28997 1.16699 9.33464 2.21166 9.33464 3.50033V5.83366H8.16797V3.50033C8.16797 2.85599 7.64563 2.33366 7.0013 2.33366C6.35697 2.33366 5.83464 2.85599 5.83464 3.50033V5.83366H4.66797V3.50033Z",
    fill: "#CD6457"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66536 5.25C3.3767 5.25 2.33203 6.29467 2.33203 7.58333V10.5C2.33203 11.7887 3.3767 12.8333 4.66536 12.8333H9.33203C10.6207 12.8333 11.6654 11.7887 11.6654 10.5V7.58333C11.6654 6.29467 10.6207 5.25 9.33203 5.25H4.66536Z",
    fill: "#CD6457"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.a277885ce31631d9b842d41d0e760e51.svg";
export { ForwardRef as ReactComponent };